import { Alert, AlertIcon, Box, Button, HStack, Text } from '@chakra-ui/react';
import { useInvoiceDetailPage } from './detail/useInvoiceDetailPage';
import { InvoiceDetailLoadingSkeleton } from './detail/InvoiceDetailLoadingSkeleton';
import { InvoiceDetailView } from './detail/InvoiceDetailView';

const InvoiceDetail = () => {
    const page = useInvoiceDetailPage();

    if (page.showLoadingSkeleton) {
        return <InvoiceDetailLoadingSkeleton />;
    }

    if (page.error) {
        return (
            <Box w="100%" maxW="1400px">
                <Alert status="error" borderRadius="lg">
                    <AlertIcon />
                    <HStack w="100%" justifyContent="space-between">
                        <Text>Failed to load invoice details. Please try again.</Text>
                        <Button size="sm" colorScheme="red" variant="outline" onClick={() => page.refetch()}>
                            Retry
                        </Button>
                    </HStack>
                </Alert>
            </Box>
        );
    }

    if (!page.invoice) {
        return (
            <Box w="100%" maxW="1400px">
                <Alert status="info" borderRadius="lg">
                    <AlertIcon />
                    Invoice not found.
                </Alert>
            </Box>
        );
    }

    return <InvoiceDetailView page={page} />;
};

export default InvoiceDetail;
